const windowAlert = (title: string, message?: string) => (
    // eslint-disable-next-line no-alert
    window.alert(`
        ${title}
        ${message}
    `)
)

export default windowAlert
